import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateClientPackageComponent } from "./create-client-package/create-client-package.component";
import { ClientService } from '../../services/client.service';
import { PackageService } from 'src/app/private/services/package.service';
import { MessageService } from 'primeng/api';
import { Menu } from 'primeng/menu';



@Component({
  selector: 'app-client-package',
  imports: [SharedModule, CreateClientPackageComponent],
  templateUrl: './client-package.component.html',
  styleUrl: './client-package.component.scss'
})
export class ClientPackageComponent {

  @Input() clientId: string = '';
  @Output() editClientPackage = new EventEmitter<any>();
  @Output() deleteClientPackage = new EventEmitter<any>();
  @Output() openClientPackage = new EventEmitter<any>();

  displayAddModal: boolean = false;
  clientDataToEdit: any = null;
  showDeleteModal: boolean = false;
  displayEditModel: boolean = false;
  selectedClientPackage : any = {}
  allPackages: any[] = [];
  allClients: { label: string; value: string }[] = [];
  selectedClientFilter: string | null = null;
  isDeleting : boolean = false;
  rows = 50;
  totalRecords = 0;
  loading = false;
invoiceModalVisible = false;
  selectedPackage: any;
  newSelectedPackage: any;
invoiceTypeFilter: 'TAX' | 'PROFORMA' | 'ALL' = 'ALL';
isOpen:boolean = false
invoices: any[] = [];
loadingInvoices = false;
rowActions: any[] = [];
@ViewChild('menu') menu!: Menu;
menuItems:any = [];
showProformaModal:boolean = false;
showUpdateModal:boolean = false;
handleClose(){
 this.showProformaModal = false
 this.showUpdateModal = false;
}

updatePackage(pkg:any){
  this.showUpdateModal = true;
}
openMenu(event: any, pkg: any) {

  this.selectedPackage = pkg;
  console.log(pkg)
  this.menu.toggle(event);
  this.menuItems = [];
  if(pkg.status=="Cancelled" && pkg.billing_paused==false && pkg.ends_at==null) {
    this.menuItems.push(
       {
     label: 'Reactivate Account',
    icon: 'pi pi-file',
    command: () => this.reactivateAccount(this.selectedPackage)
  }
    )
  }

  if(pkg.status=="Active") {
    this.menuItems.push(
       {
     label: 'Upgrade Package',
    icon: 'pi pi-file',
    command: () => this.showUpgradePackage(this.selectedPackage)
      }
    )
  }

  if(pkg.billed_occurrences==0 && pkg.status === "Inactive") {
    this.menuItems.push(
       {
      label: 'Generate Invoice',
      icon: 'pi pi-file',
     command: () => (this.showProformaModal = true),
      }
    )
  }
  
  
  if ((pkg.status === "Active" || pkg.status === "Inactive") && pkg.next_billing_at) {
    const nextBillingDate = new Date(pkg.next_billing_at);
    const reminderDays = pkg.reminder_before_days || 0;
    
    const reminderDate = new Date(nextBillingDate);
    reminderDate.setDate(nextBillingDate.getDate() - reminderDays);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    reminderDate.setHours(0, 0, 0, 0);

    if (today.getTime() >= reminderDate.getTime()) {
      this.menuItems.push({
        label: 'Generate Monthly Invoice',
        icon: 'pi pi-file',
        command: () => (this.showProformaModal = true),
      });
    }
  }
  this.menuItems.push({
     label: 'Billing & Invoices',
    icon: 'pi pi-file',
    command: () => this.fetchInvoices()
  },
  
  { separator: true },
  {
    label: 'Edit',
    icon: 'pi pi-pencil',
    command: () => this.setClientData(this.selectedPackage)
  },
  {
    label: 'Delete',
    icon: 'pi pi-trash',
    styleClass: 'p-menuitem-danger',
    command: () => this.setDelete(this.selectedPackage)
  })
    
   
  
  

  


}  
reactivateAccount(pkg:any){
let payload = {
      "old_package_subscription_id": pkg.id,
      "client_id": pkg.client_id,
    }
    this.invoiceBtnLoading = true;
    this.packageService.restartSubscription(payload).subscribe({
      next: (res : any) => {
        console.log(res)
          this.messageService.add({
            severity: 'success',
            summary: `Success`,
            detail: res.message
          });
       this.invoiceBtnLoading = false;
      },
      error: (err) => {
        console.log(err)
         this.messageService.add({
            severity: 'error',
            summary: err.error.refund_status,
            detail: err.error.message
          });
        this.loading = false;
          this.invoiceBtnLoading = false;
      }
    });
}
  
  constructor(
    private clientService: ClientService,
    private packageService: PackageService,
    private messageService: MessageService
  ) { }

  clientPackage: any;
  invoiceBtnLoading:boolean = false;


  ngOnInit() {
    this.getClientPackage();
    this.getAllPackages();
    this.loadAllClients();
  }

  openAddModal() {
    this.openClientPackage.emit()
  }

openInvoiceModal(pkg: any, type: 'TAX' | 'PROFORMA') {
  this.selectedPackage = pkg;
  this.invoiceTypeFilter = type;
  this.invoiceModalVisible = true;
  //alert(this.invoiceModalVisible)
  //this.fetchInvoices();
}

fetchInvoices() {
  this.invoiceModalVisible = true;
  this.loadingInvoices = true;

  this.packageService.getAllPackageInvoices({
    package_subscription_id: this.selectedPackage.id,
    client_id:this.selectedPackage.client_id,
    invoice_type: this.invoiceTypeFilter // TAX | PROFORMA
  }).subscribe({
    next: (res: any) => {
      this.invoices = res.data || [];
      this.loadingInvoices = false;
    },
    error: () => this.loadingInvoices = false
  });
}
  upgradeablePackages: any[] = [];

  showUpgradePackage(pkg: any) {
    this.selectedPackage = pkg;
    this.newSelectedPackage = null;
    
    // Filter packages with price greater than current package price
    const currentPrice = parseFloat(pkg.package?.price || pkg.package?.amount || 0);
    this.upgradeablePackages = this.allPackages.filter(p => {
      const packagePrice = parseFloat(p.price || p.amount || 0);
      return packagePrice > currentPrice;
    });

    this.showUpdateModal = true;
  }

upgradePackage() {
  if (!this.newSelectedPackage) return;
  const payload = {
      client_id: this.selectedPackage.client_id, // assuming client_id is on the package subscription object
      old_package_subscription_id: this.selectedPackage.id,
      new_package_id: this.newSelectedPackage.package_id || this.newSelectedPackage.id
  };
  this.invoiceBtnLoading = true;
  this.packageService.upgradePackageSubscription(payload).subscribe({
    next: (res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message
      });
      this.invoiceBtnLoading = false;
      this.showUpdateModal = false;
      this.reload();
    },
    error: (err) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err.error?.message || 'Failed to upgrade package'
      });
      this.invoiceBtnLoading = false;
    }
  });
}
getRowActions(pkg: any) {
  return [
   {
  label: 'Billing & Invoices',
  icon: 'pi pi-file',
  disabled: this.invoiceBtnLoading,
  command: () => this.openInvoiceModal(pkg, 'TAX')
},

    {
      separator: true
    },
    {
      label: 'Edit',
      icon: 'pi pi-pencil',
      command: () => this.setClientData(pkg)
    },
    {
      label: 'Delete',
      icon: 'pi pi-trash',
      command: () => this.setDelete(pkg),
      styleClass: 'p-menuitem-danger'
    }
  ];
  
}

viewInvoice(inv: any) {
  window.open(inv.invoice_url, '_blank');
}

downloadInvoice(inv: any) {
  window.open(inv.invoice_url, '_blank');
}


fnCancelAndRefundSubscription(inv: any){

  let payload = {
      "package_subscription_id": inv.package_subscription_id,
      "client_id": inv.client_id,
      "refund_type": "PRORATED",
      "refund_reason":"Subscription cancelled",
    }
    this.invoiceBtnLoading = true;
    this.packageService.cancelAndRefundSubscription(payload).subscribe({
      next: (res : any) => {
        console.log(res)
          this.messageService.add({
            severity: 'success',
            summary: `Success`,
            detail: res.message
          });
       this.invoiceBtnLoading = false;
      },
      error: (err) => {
        console.log(err)
         this.messageService.add({
            severity: 'error',
            summary: err.error.refund_status,
            detail: err.error.message
          });
        this.loading = false;
          this.invoiceBtnLoading = false;
      }
    });
}

resendInvoice(inv: any) {
  // this.invoiceService.resendInvoice(inv.id).subscribe(() => {
  //   this.messageService.add({
  //     severity: 'success',
  //     summary: 'Invoice sent',
  //     detail: 'Invoice email resent successfully'
  //   });
  // });
  console.log(inv)

  let payload = {
      "package_subscription_id": inv.package_subscription_id,
      "client_id": inv.client_id,
      "invoice_origin": "PROFORMA",
      "proforma_invoice_id":inv.invoice_id,
    }
    this.invoiceBtnLoading = true;
    this.packageService.generatePackageInvoice(payload).subscribe({
      next: (res : any) => {
        console.log(res)
          this.messageService.add({
            severity: 'success',
            summary: `Success`,
            detail: res.message
          });
       this.invoiceBtnLoading = false;
      },
      error: (err) => {
         console.log(err)
         this.messageService.add({
            severity: 'error',
            summary: err.error.refund_status,
            detail: err.error.message
          });
          this.loading = false;
          this.invoiceBtnLoading = false;
    
      }
    });
    
}
  
  generateBill(data:any) {
    console.log(data)
    let payload = {
      "package_subscription_id": data.id,
      "client_id": data.client_id
    }
    this.invoiceBtnLoading = true;
    this.packageService.proformaPackageInvoice(payload).subscribe({
      next: (res : any) => {
        console.log(res)
          this.messageService.add({
            severity: 'success',
            summary: `Success`,
            detail: res.message
          });
        setTimeout(() => {
          this.showProformaModal = false;
          this.reload();
        }, 1000);   
       this.invoiceBtnLoading = false;
      },
      error: (err) => {
         this.messageService.add({
            severity: 'error',
            summary: err.error.refund_status,
            detail: err.error.message
          });
          setTimeout(() => {
          this.showProformaModal = false;
          this.reload();
        }, 1000);   
        this.loading = false;
          this.invoiceBtnLoading = false;
      }
    });
    
  }


  getClientPackage(clientId?: string) {
    const whereClause: any = {};
    if (clientId) {
      whereClause['client_id'] = clientId;
    }

    const payload = {
      "page": 0,
      "limit": 10,
      "where": whereClause,
    "order": {
        "col": "\"package_subscription\".\"updatedAt\"",
        "dir": "DESC"
    }
    }

    this.loading = true;

    this.packageService.getAllPackageSubscription(payload).subscribe({
      next: (res : any) => {
        if(res){
          this.clientPackage = res.rows;
        }else{
          this.clientPackage = [];
        }
        console.log("cltpackage",this.clientPackage);
        this.totalRecords = this.clientPackage.length;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      }
    });
  }

  onClientFilterChange(clientId: string | null) {
    this.selectedClientFilter = clientId;
    this.getClientPackage(clientId || undefined);
  }

  loadAllClients() {
    const payload = {
      page: 0,
      limit: 500,
      where: {},
      order: { col: '"client"."name"', dir: 'ASC' }
    };
    this.clientService.getAllClients(payload).subscribe({
      next: (res: any) => {
        const rows = res.rows || res.data || [];
        this.allClients = rows.map((c: any) => ({
          label: c.name,
          value: c.client_id || c.id
        }));
      },
      error: () => {}
    });
  }

  reload() {
    this.getClientPackage(this.selectedClientFilter || undefined);
  }


  getAllPackages() {
    const payload = {
      "page": 0,
          "limit": 10,
          "where": {},
          "order": {
            "col": "\"package\".\"updatedAt\"",
            "dir": 'DESC'
          }
    }
    this.loading = true;
    this.packageService.getAllPackage(payload).subscribe({
      next: (res) => {
        this.allPackages = res.rows || [];
        console.log("All Packages:", this.allPackages);
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      }
    });
  }

setDelete
(clientData: any) {
    this.clientDataToEdit = clientData;
    this.showDeleteModal = true
    //this.deleteClientPackage.emit(clientData)
  }
  setClientData(clientData: any) {
    this.clientDataToEdit = clientData;
    this.editClientPackage.emit(clientData)
  }


 deleteAddonConfirm(){
    const payload = {
      id: this.clientDataToEdit.id,
    }

    this.loading = true;
    this.packageService.deletePackageSubscription(payload).subscribe({
      next: (res) => {
        this.loading = false;
          this.reload();
          this.showDeleteModal = false
      },
      error: (err) => {
        this.loading = false;
      }
    });
  
 }


}
